import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { notificationStore } from '../../../store/notificationStore';

import { NotificationsType } from '../../../core/constants/notificationsType';

import Maintenance from './maintenance';
import SpinResponseMessage from './betResponse';

const Notification = observer(() => {
  const { notificationTypes, operatorError } = notificationStore;

  const NotificationComponent = useMemo(() => {
    return {
      [NotificationsType.Maintenance]: Maintenance,
      [NotificationsType.SpinResponseCode]: SpinResponseMessage,
    };
  }, []);

  if (!notificationTypes.length && !operatorError) {
    return null;
  }

  return notificationTypes.map(({ type, notificationInfo }, index) => {
    const CurrentComponent = NotificationComponent[type];
    return (
      <Container key={type} y={index * 60}>
        <CurrentComponent notificationInfo={notificationInfo} operatorError={operatorError} />
      </Container>
    );
  });
});

export default Notification;
